import { ConfirmationDialogController } from './confimation-dialog.controller'

function confirmationDialog () {
  return {
    restrict: 'E',
    controller: ConfirmationDialogController,
    templateUrl: '/core/dialogs/confirmation-dialog/confirmation-dialog.html?$$REVISION$$'
  }
}
export { confirmationDialog }
